import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#59d0ff',
      light: '#8fe1ff',
      dark: '#1ca9e4',
    },
    secondary: {
      main: '#0f172a',
      light: '#18243a',
      dark: '#060b16',
    },
    background: {
      default: '#050816',
      paper: '#09111f',
    },
    text: {
      primary: '#f8fbff',
      secondary: '#9cb3c9',
    },
  },
  typography: {
    fontFamily: '"Inter", "Arial", sans-serif',
    h1: {
      fontFamily: '"General Sans", "Inter", sans-serif',
      fontSize: 'clamp(3rem, 6vw, 5.5rem)',
      fontWeight: 700,
      lineHeight: 1.02,
      letterSpacing: '-0.04em',
    },
    h2: {
      fontFamily: '"General Sans", "Inter", sans-serif',
      fontSize: 'clamp(2rem, 4vw, 3.4rem)',
      fontWeight: 700,
      lineHeight: 1.08,
      letterSpacing: '-0.03em',
    },
    h3: {
      fontFamily: '"General Sans", "Inter", sans-serif',
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: '"General Sans", "Inter", sans-serif',
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.75,
    },
    button: {
      textTransform: 'none',
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
  },
  shape: {
    borderRadius: 20,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#050816',
          backgroundImage:
            'radial-gradient(circle at top, rgba(89, 208, 255, 0.16) 0%, rgba(5, 8, 22, 0) 34%), radial-gradient(circle at bottom, rgba(24, 52, 92, 0.35) 0%, rgba(5, 8, 22, 0) 28%)',
        },
        a: {
          color: 'inherit',
        },
        '::selection': {
          backgroundColor: 'rgba(89, 208, 255, 0.3)',
          color: '#ffffff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          padding: '0.9rem 1.6rem',
          fontSize: '1rem',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 18px 40px rgba(89, 208, 255, 0.18)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage:
            'linear-gradient(180deg, rgba(14, 24, 43, 0.92) 0%, rgba(7, 12, 24, 0.96) 100%)',
          border: '1px solid rgba(151, 190, 219, 0.14)',
          borderRadius: 28,
          boxShadow: '0 18px 60px rgba(2, 6, 23, 0.45)',
          backdropFilter: 'blur(18px)',
        },
      },
    },
  },
});

export default theme;
